<template>
  <div class="article-cta">
    <h3 v-if="title" class="article-cta__title">{{ title }}</h3>
    <b-main v-if="href" class="article-cta__link" v-bind="buttonProps" />
  </div>
</template>

<script>
import MainButton from '../../button/mainButton'

export default {
  components: {
    'b-main': MainButton,
  },
  computed: {
    /**
     * Link button props binding
     */
    buttonProps() {
      const props = {
        style: this.buttonStyles,
        title: this.alt || this.$t('general.more'),
      }
      if (this.href.startsWith('http')) {
        // External link
        props.href = this.href
        props.target = '_blank'
      } else {
        // Internal link
        props.linkPath = this.href
      }

      return props
    },

    /**
     * Link button styles
     */
    buttonStyles() {
      const styles = {}
      if (this.backgroundColor) {
        styles['background-color'] = this.backgroundColor
      }
      if (this.textColor) {
        styles.color = this.textColor
      }

      return styles
    },
  },
  props: {
    /**
     * Link alternative text
     */
    alt: {
      default: '',
      type: String,
    },

    /**
     * Link button background color
     */
    backgroundColor: {
      default: '',
      type: String,
    },

    /**
     * Link URL
     */
    href: {
      default: '',
      type: String,
    },

    /**
     * Link button text color
     */
    textColor: {
      default: '',
      type: String,
    },

    /**
     * Call-to-action title
     */
    title: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-cta {
  @apply flex flex-col items-center;

  & .article-cta__title {
    @apply mt-0 mb-5;
  }
  & .article-cta__link {
    @apply px-12;
  }
}

@screen mobile {
  .article-cta {
    & .article-cta__link:focus {
      @apply no-underline;
    }
  }
}

@screen desktop {
  .article-cta {
    & .article-cta__link:hover {
      @apply no-underline;
    }
  }
}
</style>
